import { endpoints } from "../../services/endpoint.ts/endpoint";
import { getData } from "../api/action";

export const getCancelUpload = async (payload) => {
  const response = await getData({
    url: `${endpoints.GET_CANCEL_UPLOAD.url}?guid=${payload?.guidValue}`,
  });
  return response;
};
